import * as React from 'react';
import WithDragDropContext from '../withdrag-dropcontext';
class DragDropContainer extends React.Component {
    render() {
        return (<div>
        {this.props.children}
      </div>);
    }
}
export default WithDragDropContext(DragDropContainer);



// WEBPACK FOOTER //
// ./components/drag/DragContainer.tsx